import {Layout} from 'components/layout';
import React from 'react';
import {PaymentsItem} from '../payments-item/payments-item';

export const Payments = () => {
  const paymentList = [
/*     {
      title: 'Ипотека',
      dialogTitle: 'Расчет ежемесячного платежа по ипотеке',
      celtype: 'getPaymentMortgage'
    }, */
    {
      title: '100% оплата',
      dialogTitle: 'Расчет ежемесячного платежа по ипотеке',
      celtype: 'getPaymentFull'
    },
    {
      title: 'Рассрочка',
      dialogTitle: 'Расчет ежемесячного платежа по рассрочке',
      celtype: 'getPaymentInstallment'
    },
  ];

  return (
    <section className="mt-[72px] font-open-sans bg-plt-secondary/50 rounded-[40px] screen-750:rounded-none">
      <Layout.Container>
        <div className="py-10 px-[33px] screen-750:px-0 screen-750:py-6">
          <h3 className="uppercase font-bold text-[32px] text-center text-plt-black screen-750:text-lg">
            варианты ОПЛАТЫ
          </h3>
          <div className="mt-16 flex bg-plt-white rounded-[40px] overflow-hidden screen-1300:py-10 screen-1300:mt-5">
            <div className="flex justify-center items-center w-full">
              <div className="grid grid-cols-3 gap-[32px] px-9 screen-750:grid-cols-1">
                {paymentList.map((payment) => (
                  <PaymentsItem key={payment.title} payment={payment}/>
                ))}
              </div>
            </div>
            <div className="h-[345px] w-[620px] justify-self-end shrink-0 screen-1300:hidden">
              <img
                className="w-full h-full object-cover"
                src="/assets/images/png/moving.jpg"
                alt="moving"
              />
            </div>
          </div>
        </div>
      </Layout.Container>
    </section>
  );
};
